








































import { Component, Prop, Mixins } from "vue-property-decorator";
import i18n from "@/i18n";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Functions
import { geterateRandomString } from "@/helpers/generateCode";

@Component
export default class UGenerateCodeField extends Mixins(HasValidation) {
  // Props

  @Prop({ default: "" })
  public value!: string;

  @Prop({ default: i18n.t("_.code") })
  public fieldLabel!: string;

  @Prop({
    default: i18n
      .t("_.code")
      .toString()
      .toLowerCase()
  })
  public fieldName!: string;

  @Prop({ default: "code" })
  public fieldId!: string;

  @Prop({ default: i18n.t("_placeholder.enter_field_value") })
  public fieldPlaceholder!: string;

  @Prop({ default: true })
  public isRequired!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Getter

  public get codeField() {
    return this.value;
  }

  // Setter

  public set codeField(value) {
    this.$emit("input", value);
  }

  // Methods

  public generateCode() {
    if (this.isDisabled) return;
    this.$set(this, "codeField", geterateRandomString(8));
  }

  // Computed

  public get label() {
    return `${this.fieldLabel}${this.isRequired ? "*" : ""}`;
  }
}
